module.exports = __webpack_public_path__ + "media/images/icons/ic-media-a44ca278b111f05b6d09b355ee2e8a53.svg";